import { render, staticRenderFns } from "./PremiseWorkplace.vue?vue&type=template&id=7c0ad654&"
import script from "./PremiseWorkplace.vue?vue&type=script&lang=js&"
export * from "./PremiseWorkplace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports